import React from 'react'
import { Card, Badge } from 'react-bootstrap'
import PropTypes from 'prop-types'

const AccountAccess = ({ accessData }) => {
  if (!accessData || accessData.length === 0) {
    return null
  }

  // Filter out segments with no ranges
  const segmentsWithAccess = accessData.filter(
    (segment) => segment.ranges && segment.ranges.length > 0
  )

  if (segmentsWithAccess.length === 0) {
    return (
      <Card className="border mb-3">
        <Card.Header className="bg-white">
          <div className="text-info">GL Account Access</div>
        </Card.Header>
        <Card.Body>
          <p className="text-muted">No GL account access configured</p>
        </Card.Body>
      </Card>
    )
  }

  // Get unique ranges sorted lexicographically
  const getUniqueRanges = (ranges) => {
    const seen = new Set()
    return ranges
      .filter((range) => {
        const key = `${range.start}-${range.end}`
        if (seen.has(key)) {
          return false
        }
        seen.add(key)
        return true
      })
      .sort((a, b) => {
        const keyA = `${a.start}-${a.end}`
        const keyB = `${b.start}-${b.end}`
        return keyA.localeCompare(keyB)
      })
      .map((range) => {
        if (range.start === range.end) {
          return range.start
        }
        return `${range.start}-${range.end}`
      })
  }

  return (
    <Card className="border mb-3">
      <Card.Header className="bg-white">
        <div className="text-info">GL Account Access</div>
      </Card.Header>
      <Card.Body>
        <div className="d-flex flex-wrap align-items-center gap-3">
          {segmentsWithAccess.map((segment, index) => (
            <div key={index} className="d-flex align-items-center gap-1">
              <span className="text-muted" style={{ fontSize: '13px' }}>
                {segment.segment_name}:
              </span>
              {getUniqueRanges(segment.ranges).map((rangeValue, rangeIndex) => (
                <Badge key={rangeIndex} bg="" className="border text-primary">
                  {rangeValue}
                </Badge>
              ))}
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  )
}

AccountAccess.propTypes = {
  accessData: PropTypes.arrayOf(
    PropTypes.shape({
      segment_name: PropTypes.string.isRequired,
      access_type: PropTypes.string.isRequired,
      ranges: PropTypes.arrayOf(
        PropTypes.shape({
          start: PropTypes.string.isRequired,
          end: PropTypes.string.isRequired
        })
      ).isRequired
    })
  )
}

export default AccountAccess
